export enum align {
  left = 'left',
  center = 'center',
  right = 'right'
}

export enum state {
  default = 'DEFAULT',
  hover = 'HOVER',
  focus = 'FOCUS',
  disabled = 'DISABLED'
}

export enum selectState {
	default = 'DEFAULT',
	hover = 'HOVER',
	opened = 'OPENED',
	disabled = 'DISABLED'
}
